import clx from 'classnames'
import React, { useState } from 'react'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import { useModal } from '../../stores/useModal'

export const Stories = ({values:{path}}) => {
    const [stories, setStories] = useState([1,2,3,4,5,6])
    const [activeSlide, setActiveSlide] = useState(path||1)
    const prev = () => {
        if(activeSlide==1) return setActiveSlide(stories.length)
        if(activeSlide>0) return setActiveSlide(activeSlide-1)
    }
    const next = () => {
        if(activeSlide==stories.length) return setActiveSlide(1)
        if(activeSlide<stories.length) return setActiveSlide(activeSlide+1)
    }
    const toggle = useModal(state=>state.toggle)
    return (
        <div className='flex justify-center items-center '>
                <div
                    x-show="stories"
                    className={clx(
                        'w-[25em]'
                        // 'overflow-auto backdrop-blur-sm bg-black/30',
                        // {'fixed inset-0 z-50 flex items-center justify-center': stories }
                    )}
                >
                    <div
                    class="bg-white relative overflow-hidden lg:max-w-xl mx-auto 
                    rounded-xl shadow-lg text-left"
                    x-show="stories"
                    >
                    <div
                        onClick={()=>toggle()}
                        class="absolute right-4 top-4 cursor-pointer z-50"
                    >
                        <svg
                        class="fill-current text-black"
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        >
                        <path
                            d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                        ></path>
                        </svg>
                    </div>

                    <div class="w-screen sm:w-[325px] h-[650px] ">
                        <div class="flex flex-col justify-center items-center ">
                        <div
                            class=" w-full mx-auto absolute left-0 bottom-0 right-0 top-0"
                        >
                            {stories.map(slide=>(
                                <div
                                    class={clx(
                                        `h-screen w-full font-bold text-5xl flex items-center 
                                        justify-center bg-gray-300 text-white rounded-lg`,
                                        {'hidden':activeSlide!=slide}
                                    )}
                                >
                                    <img
                                    src={
                                        `/images/demo/stories/${slide}.png`
                                        // `/images/stories/${slide}.jpg`
                                    }
                                    class="w-full h-full object-cover"
                                    />
                                </div>
                            ))}

                            <div class="absolute inset-0 flex">
                            <div class="flex items-center justify-start w-1/2">
                                <div
                                onClick={prev}
                                  className={clx(
                                    `bg-white/50 text-gray-400/80 hover:text-orange-500 font-bold hover:shadow-lg rounded-full 
                                    w-8 h-8 flex items-center justify-center cursor-pointer ml-2`,
                                    // activeSlide = activeSlide === 1 ? slides.length : activeSlide - 1
                                  )}
                                >
                                   <FiChevronLeft size={23} class="w-5 h-5 stroke-3 stroke-gray-500" />
                                </div>
                            </div>
                            <div class="flex items-center justify-end w-1/2">
                                <div
                                onClick={next}
                                className={clx(
                                    `bg-white/50 text-gray-400/80 hover:text-orange-500 font-bold 
                                    hover:shadow rounded-full w-8 h-8
                                     flex items-center justify-center cursor-pointer mr-2`,
                                    // {activeSlide = activeSlide === slides.length ? 1 : activeSlide + 1}
                                 )}
                                >
                                <FiChevronRight size={23} class="w-5 h-5 stroke-3 stroke-gray-500" />
                                </div>
                            </div>
                            </div>

                            <div
                            class="absolute w-full flex items-center justify-center px-4 bottom-0"
                            >
                               {stories.map(slide=>(
                                 <button
                                 className={clx(
                                    `flex-1 w-4 h-2 -mt-10 mx-2 mb-0 rounded-full overflow-hidden transition-colors 
                                    duration-200 ease-out dark:hover:bg-gray-600/dark:40 hover:shadow-lg`,
                                    { 
                                        'bg-gray-600/70': activeSlide === slide,
                                        'bg-gray-300/70': activeSlide !== slide 
                                    }
                                 )}
                                 onClick={()=>setActiveSlide(slide)}
                                 ></button>
                             ))}
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                
        </div>
    )
}


